<template>
  <div 
    class="step" 
    ref="stepRef" 
    :class="{ 'active': isActive }"
  >
    <div 
      class="step-content"
      v-show="isActive || !initialized"
    >
      <slot :is-active="isActive" :step-index="stepIndex"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, inject, watch, nextTick } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: null
  },
  isRequired: {
    type: Boolean,
    default: false
  },
  isValid: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['step-mounted', 'step-unmounted'])

const registerStep = inject('registerStep')
const unregisterStep = inject('unregisterStep')
const activeStep = inject('activeStep')
const stepIndex = ref(0)
const stepRef = ref(null)
const initialized = ref(false)

const isActive = computed(() => activeStep.value === stepIndex.value)

const id = Symbol('step')

const findStepIndex = () => {
  if (!stepRef.value) return 0
  
  const allSteps = Array.from(document.querySelectorAll('.step'))
  const currentStep = stepRef.value
  const index = allSteps.indexOf(currentStep)
  return index >= 0 ? index : 0
}

const registerCurrentStep = () => {
  const index = findStepIndex()
  stepIndex.value = index
  
  updateStepData()
  
  nextTick(() => {
    initialized.value = true
  })
}

const updateStepData = () => {
  registerStep({
    id,
    index: stepIndex.value,
    title: props.title,
    isRequired: props.isRequired,
    isValid: props.isValid
  })
}

watch(() => props.isValid, updateStepData)
watch(() => props.isRequired, updateStepData)
watch(() => props.title, updateStepData)

onMounted(async () => {
  await nextTick()
  setTimeout(registerCurrentStep, 100)
})

onUnmounted(() => {
  unregisterStep(id)
  emit('step-unmounted', { id, index: stepIndex.value })
})
</script>

<style scoped>
.step {
  width: 100%;
  transition: all 0.3s ease-in-out;
}
</style> 